import { FetchAPI } from '@philips-internal/oswald-ui-components';
import { HistoryService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { Endpoint } from '../constants/endpoints';
import { ApplicationRoute } from '../constants/routes';
import { ListPendingParams } from '../interfaces/exam-collect/pending-exam-collection';
import { FoundationUtils } from './foundation-utils';

const historyService = HistoryService;

interface MedicalPrescriptions {
  data: string;
  ieRn: string;
  nmMdPrescr: string;
  nrPrescription: number;
}

export class ExamCollectionUtils {
  private static getParam(parameterTwsOrTasy: string): string {
    if (FoundationUtils.hasModuleParam('EXAM_COLLECT#9130', parameterTwsOrTasy)) {
      return FoundationUtils.findModuleParam('EXAM_COLLECT#9130', parameterTwsOrTasy) as string;
    }

    return '';
  }

  public static updateExamsOrRedirect(fetchPendingExam: FetchAPI): void {
    const { encounterId, prescriptionId } = historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.EXAM_COLLECT_LIST_PENDING, {
      encounterNumber: encounterId,
      limit: 1,
      page: 0,
      prescriptionNumber: prescriptionId,
    }).then(response => {
      const body = response.body as ListPendingParams[];
      if (body.length > 0) {
        fetchPendingExam.forceFetch();
      } else {
        this.handleEmptyMedicalPrescriptionsCase(encounterId as string);
      }
    });
  }

  private static handleEmptyMedicalPrescriptionsCase(encounterId: string | number): void {
    const exist = ExamCollectionUtils.existsMedicalPrescriptions(encounterId);

    exist.then(res => {
      if (res) {
        applicationContext.popNavigationItem();
      } else {
        applicationContext.clearNavigationStack();
        historyService.push(
          `${ApplicationRoute.EXAM_COLLECTION}${ApplicationRoute.SEARCH_PATIENT}`
        );
      }
    })
  }

  public static existsMedicalPrescriptions(encounterId: string | number): Promise<boolean> {
    const paramlaboratory = this.getParam('USE_LABORATORY_SAMPLE_STANDARD#2');
    const statusExam = this.getParam('PENDING_EXAMS_STATUS#3');
    const qtValid = this.getParam('HOURS_PRESCRIPTIONS_COLLECTION#4');
    const qtHoursRecollect = this.getParam('HOURS_PRESCRIPTIONS_RECOLLECT#5');
    const dtPrevPrescriptions = this.getParam('DISPLAY_EXPECTED_DATE_PRESCRIPTIONS#6');
    const groupExam = this.getParam('EXAMS_GROUPS_RELEASED_PREVIEW#7');

    const params = {
      dtprevprescriptions: dtPrevPrescriptions,
      encounterId,
      groupexam: groupExam,
      limit: 12,
      page: 0,
      paramlaboratory,
      qthours: qtValid ? qtValid : 0,
      qthoursrecollect: qtHoursRecollect ? qtHoursRecollect : 0,
      qtvalid: qtValid ? qtValid : 0,
      qtvalidrecollect: qtHoursRecollect ? qtHoursRecollect : 0,
      statusexam: statusExam,
    }

    return HttpService.get(Endpoint.EXAM_COLLECT_MEDICAL_PRESCRIPTION_LIST, params)
      .then(response => {
        const responseBody = response.body as MedicalPrescriptions[];
        return responseBody.length > 0;
      });
  }
}